import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable()
export class SnackBarService {

    constructor(private snackBar: MatSnackBar) {

    }

    public exibeSnackBarWarning(message: string, duracao? : number) {
        let duracaoSnack = duracao == null ? 3000 : duracao;
        this.snackBar.open(message, null, {
            duration: duracaoSnack,
            panelClass: ['snackPersonalizadoWarning'],
            verticalPosition: 'top'
        });
    }

    public exibeSnackBarDanger(message: string, duracao? : number) {
        let duracaoSnack = duracao == null ? 3000 : duracao;
        this.snackBar.open(message, null, {
            duration: duracaoSnack,
            panelClass: ['snackPersonalizadoDanger'],
            verticalPosition: 'top'
        })
    }
}